<template>
    <section>
    <b-card class="mb-1 sticky-top" style="height: 58px; font-family: NanumBarunGothic; padding: 1.0rem 1.5rem;" no-body>
      <b-row>
        <b-col xl="11" md="11" sm="11">
          <b-row class="d-flex align-items-center justify-content-start">
            <span class="bg-primary round text-white ml-2" style="width: 80px; font-size: 16px; font-weight: 400; margin-right: 5px; text-align: center;">기간</span>
            <flat-pickr
              class="form-control border-2"
              style="height: 32px; width: 180px; text-align: center; font-size: 12px; font-weight: 600; margin-left: 5px;"
              placeholder="YYYY-MM ~ YYYY-MM"
              :config="configs.monthSelect" 
              :value="form.monthSelect"
              @on-open="datePickerOnOpen"
              @on-change="datePickerOnChange"
              @on-close="datepickerCloseHandler"
            />
            <span class="bg-primary round text-white ml-5" style="width: 80px; font-size: 16px; font-weight: 400; margin-right: 5px; text-align: center;">조건</span>
            <vue-select
              class="major-class"
              label="title"            
              :options="majorClassList"
              :clearable="true"
              v-model="selectedMajorClass"
              placeholder="대분류(전체)"
              style="height: 32px; width: 180px; text-align: center; font-size: 12px; font-weight: 600; margin-left: 5px;"
            >
            </vue-select>
            <vue-select
              class="middle-class"
              label="title"            
              :options="middleClassList"
              :clearable="true"
              v-model="selectedMiddleClass"
              placeholder="중분류(전체)"
              style="height: 32px; width: 180px; text-align: center; font-size: 12px; font-weight: 600; margin-left: 5px;"
            >
              <template v-slot:no-options >
                <em style="opacity: 0.5; font-size: 12px;">대분류 항목을 선택하세요.</em>
              </template>
            </vue-select>
            <vue-select
              class="first-attribute"
              label="title"            
              :options="firstAttributeList"
              :clearable="true"
              v-model="selectedFirstAttribute"
              placeholder="속성(전체)"
              style="height: 32px; width: 180px; text-align: center; font-size: 12px; font-weight: 600; margin-left: 5px;"
            >
              <template v-slot:no-options >
                <em style="opacity: 0.5; font-size: 12px;">대분류 항목을 선택하세요.</em>
              </template>
            </vue-select>
            <vue-select
              class="second-attribute mr-5"
              label="title"            
              :options="secondAttributeList"
              :clearable="true"
              v-model="selectedSecondAttribute"
              placeholder="세부 속성(전체)"
              style="height: 32px; width: 180px; text-align: center; font-size: 12px; font-weight: 600; margin-left: 5px;"
            >
              <template v-slot:no-options >
                <em style="opacity: 0.5; font-size: 12px;">속성 항목을 선택하세요.</em>
              </template>
            </vue-select>
            <v-divider
              thickness="10"
              class="border-opacity-100"
              style="border-width: 1.2px; margin-top: 3px; margin-bottom: 1px; border-color: #d8d6de;"
              vertical
            />
            <b-button class="ml-5" id="analysis" style="height: 28px; width: 80px; padding: 0.5rem 0.85rem; margin-left: 5px;" @click="runAnalysis">
              분석하기
            </b-button>
          </b-row>
        </b-col>
        <b-col xl="1" md="1" sm="1">
          <b-row class="d-flex align-items-center justify-content-end">
            <b-button id="exp_pdf" style="height: auto; width: 40px; padding: 0.6rem 0.85rem; margin-right: 5px;" @click="exportToPDF">
              <div v-if="isPdfExporting" class="spinner-border spinner-border-sm"></div>
              <div v-else>
                <i class="fa-regular fa-file-pdf fa-lg"/>
              </div>
            </b-button>
            <b-tooltip target="exp_pdf" triggers="hover"> Export to PDF </b-tooltip>
            <b-button id="exp_xls" style="height: auto; width: 40px; padding: 0.6rem 0.85rem; margin-right: 5px;" @click="exportToExcel">
              <div v-if="isXlsExporting" class="spinner-border spinner-border-sm"></div>
              <div v-else>
                <i class="fa-regular fa-file-excel fa-lg"/>
              </div>
            </b-button>    
            <b-tooltip target="exp_xls" triggers="hover"> Export to Excel </b-tooltip>  
          </b-row>
        </b-col>
      </b-row>
    </b-card>
    
    <b-card ref="comPrintArea1" class="mb-1" style="font-family: 'NanumBarunGothic'; padding: 0.2rem 1.5rem;" no-body>
      <b-row>
        <b-col cols="5" style="text-align: left; color:whitesmoke; font-size: 14px; margin-left: 1.0rem; margin-top: 1.0rem; padding: 5px; background-color:lightslategray; border-radius: 5px;">
          💡 인식과 판매 데이터를 통해서 파악되지 않은, 카테고리에 대한 소비자 이해도를 확인합니다.
        </b-col>
      </b-row>
      <b-row style="margin-top: 10px;">
        <b-col style="text-align:center;">
          <h1>브랜드 검색 점유율</h1>
        </b-col>
      </b-row>
      <b-row style="margin-top: 5px;">
        <b-col id="competitionDonutCol" xl="6" md="6" sm="6" style="position: relative;">
          <div id="loadingDonut" class="text-center text-primary my-2" style="position: absolute; top: 40%; left: 40%; visibility: visible;">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>분석중...</strong>
          </div>
          <div id="donutChart" style="visibility: hidden;">
            <competition-chart-donut
              :donutChartData="donutChartData"
              :totalFreq="totalFreq"
            />
          </div>
        </b-col>
        <b-col id="competitionBarCol" xl="6" md="6" sm="6" style="position: relative; min-height: 500px;">
          <div id="loadingBar" class="text-center text-primary my-2" style="position: absolute; top: 40%; left: 40%; visibility: visible;">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>분석중...</strong>
          </div>
          <div class="graphic-container" id="barChart" style="visibility: hidden;">
            <competition-chart-bar
              :height="height"
              :barChartData="barChartData"
              :barChartFreq="barChartFreq"
              :barChartCategory="barChartCategory"
              :totalFreq="totalFreq"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="6" md="6" sm="6">
          <div v-if="this.donutChartData.length > 0" style="border-width: 2px; border-color: #b4bec8; border-style: solid; border-radius: 5px; background-color: aliceblue; margin-bottom: 5px;">          
            <div style="text-align: left; color: #5e5873; font-size: 13px; margin-left: 5px; margin-top: 5px;">
              <div style="margin-bottom: 4px;"> 
                • 📅 <b>{{ this.sel_date_from }} ~ {{ this.sel_date_to }}</b> 기간동안 <b>{{ this.sel_category_title }}</b> 카테고리의 총검색량은 <b>{{ this.totalFreq.toLocaleString() }}</b> 건 입니다.
              </div>
              <div style="margin-bottom: 8px;">
                • 이 중 <b>NONBRANDED</b> 검색량은 <b>{{ this.nonbrand_share_rate }}%</b>를 차지하였고, <b>BRANDED</b> 검색량은 <b>{{ this.brand_share_rate }}%</b>를 차지하였습니다.
              </div>              
            </div>
            <div v-if="this.nonbrand_share_rate > 65.0" style="font-size: 13px; color: #1951dc; margin-left: 5px; margin-bottom: 5px;">
              👉 소비자는 <b>{{ this.sel_category_title }}</b> 에 대해, 주요 브랜드를 인식하지 못하고 있다고 볼 수 있습니다.
            </div>
            <div v-if="this.brand_share_rate > 65.0" style="font-size: 13px; color: #1951dc; margin-left: 5px; margin-bottom: 5px;">
              👉 소비자는 <b>{{ this.sel_category_title }}</b> 에 대해, 주요 브랜드를 인식하고 있다고 볼 수 있습니다.
            </div>
          </div>
        </b-col>
        <b-col xl="6" md="6" sm="6">
          <div v-if="this.barChartData.length > 0" style="border-width: 2px; border-color: #b4bec8; border-style: solid; border-radius: 5px; background-color: aliceblue; margin-bottom: 5px;"> 
            <div style="text-align: left; color: #5e5873; font-size: 13px; margin-left: 5px; margin-top: 5px;">
              <div v-if="this.brandList.length == 1" style="margin-bottom: 2px;">
                • 가장 많이 검색된 브랜드는 🥇<b>{{ this.brandList[0] }}</b> 입니다.
              </div>
              <div v-else-if="this.brandList.length == 2" style="margin-bottom: 2px;">
                • 가장 많이 검색된 브랜드는 🥇<b>{{ this.brandList[0] }}</b> 였으며, 그 뒤를 🥈<b>{{ this.brandList[1] }}</b> 가 쫓고 있습니다.
              </div>
              <div v-else-if="this.brandList.length > 2" style="margin-bottom: 2px;">
                • 가장 많이 검색된 브랜드는 🥇<b>{{ this.brandList[0] }}</b> 였으며, 그 뒤를 🥈<b>{{ this.brandList[1] }}</b>, 🥉<b>{{ this.brandList[2] }}</b> 가 쫓고 있습니다.
              </div>
            </div>
            <div style="font-size: 13px; color: #1951dc; margin-bottom: 5px; margin-left: 5px;">
              👉 알고 있는 시장 점유율과 함께 분석하여, 향후 마케팅 전략을 수립할 수 있습니다.
            </div>
            <div style="text-align: left; color: #5e5873; font-size: 11px; margin-left: 5px; margin-top: 5px;">
              <div style="margin-bottom: 2px;"> 1️⃣ <b>검색점유율 > 시장점유율</b>: 높은 인지도/선호도를 바탕으로 성장 가능성이 높습니다. </div>
              <div style="margin-left: 19px; margin-bottom: 5px;">상품 포트폴리오 확대, 온라인 및 판매 채널 강화, 판매목적 프로모션을 통해 매출을 높일 수 있습니다.</div>
              <div style="margin-bottom: 2px;">2️⃣ <b>검색점유율 < 시장점유율</b>: 브랜드 노후화가 일어나고 있거나, 관심에서 멀어지고 있어, 향후 시장점유율이 감소할 가능성이 높습니다.</div>
              <div style="margin-left: 19px; margin-bottom: 5px;">재포지셔닝(repositioning), 리뉴얼(renewal)을 통해 브랜드에 다시 활력(revitalization)을 불어 넣을 수 있습니다.</div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-card>

    <b-card ref="comPrintArea2" class="mb-1" style="font-family: 'NanumBarunGothic'; padding: 0.2rem 1.5rem;" no-body>
      <b-row style="margin-top: 10px;">
        <b-col cols="8" style="text-align:center;">
          <h1>브랜드 검색 점유율 트래킹</h1>
        </b-col>
        <b-col cols="4" style="text-align:center;">
          <h1>검색량 상위 키워드 50</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="5" style="margin-bottom: 10px;">
          <v-select
            id="sel-brands"
            class="select-brand"
            label="브랜드 선택(다중)"            
            :items="brandList"
            :menu-props="{ contentClass: 'comselectitemlist',
                           closeOnContentClick: true,
            }"
            multiple
            hide-details
            outlined
            dense
            v-model="selectedBrandList"
            @change="changeFilter()"
          >
          <template v-slot:prepend-item>
            <v-checkbox
              v-if="brandList.length > 1"
              class="sosselectallcond"
              v-model=isSelectAll_cond
              :color="isSelectAll_cond ? '#1817E7' : 'undefined'"
              :indeterminate="isSelectSome_cond && !isSelectAll_cond"
              :ripple="false"
              hide-details
              @click="selectAllCond"
            >
              <template v-slot:label>
                <span style="color: #1817E7; font-size: 12px; font-weight: 600; padding: 0px; margin: 4px 0px 0px 20px;">(모두 선택)</span>
              </template>
            </v-checkbox>
            <v-divider v-if="brandList.length > 1" class="sosdivider" />
          </template>
          <template v-slot:selection="{item, index}">
            <v-chip class="primary" v-if="index < 4" style="height: 24px; margin-top: 5px; font-size: 10px; font-weight: 500;" x-small close @click:close="removeSelItem(selectedBrandList, index)">{{ item }}</v-chip>
            <span
              v-if="index === 4"
              class="caption ml-1"
              style="color:#5e5873; font-family: NanumBarunGothic !important; font-weight: 600; margin-top: 8px;"
              >(+{{ selectedBrandList.length - 4 }} 브랜드)
            </span>
          </template>
          </v-select>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="8" style="position: relative; min-height: 500px;">
          <div id="loadingLine" class="text-center text-primary my-2" style="position: absolute; top: 40%; left: 45%; visibility: visible;">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>분석중...</strong>
          </div>
          <div id="lineChart" style="visibility: hidden;">
            <competition-chart-line
              :competitionChartLine="competitionChartLineSeries(lineChartData)"
              :lineChartCategories="lineChartCategories"
              :lineChartDesc="lineChartDesc"
              :isChartInit="lnChartInit"
              id="competitionChartLine"
            />
          </div>
        </b-col>
        <b-col cols="4">
          <b-table
            class="comTable position-relative"
            ref="refCompetitionTable"
            :items="fetchGroups"
            :fields="tableColumns"
            :sort-desc.sync="sortDesc" 
            :sort-by.sync="sortBy"
            :sort-direction='sortDirection'
            :busy="isBusy"
            responsive
            show-empty
            no-border-collapse
            outlined
            hover
            table-class="table-font-size"
            empty-text="해당하는 키워드가 없습니다."
            sticky-header="true"
            style="max-height: 546px;"
          >
            <template #head()="{ label, field: { key, sortable } }">
              {{ label }}
              <template v-if="sortable">
                <b-img v-if="sortBy !== key" src="/caretupdown.png" style="width: 10px;"></b-img>
                <b-img v-else-if="sortDesc" src="/caretup.png" style="width: 9px;"></b-img>
                <b-img v-else src="/caretdown.png" style="width: 9px;"></b-img>
              </template>
            </template>
            <template #table-busy>
              <div class="text-center text-primary my-2">
                <b-spinner class="align-middle mr-2"></b-spinner>
                <strong>분석중...</strong>
              </div>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="8">
          <div v-if="this.lnChartInit" style="border-width: 2px; border-color: #b4bec8; border-style: solid; border-radius: 5px; background-color: aliceblue; margin-bottom: 5px;">          
            <div style="text-align: left; color: #5e5873; font-size: 13px; margin: 5px;">
              <div v-if="this.top_rank_brand_rate_diff > 0"> 
                <div style="margin-bottom: 4px;">
                  • <b>{{ this.top_rank_brands }}</b>는 <b>{{ this.sel_date_from }}</b> 대비 <b>{{ this.sel_date_to }}</b>에 <img src="@/assets/images/etc/positive.png" style="width: 0.7rem"/> <b>{{ this.top_rank_brand_rate_diff.toFixed(1) }}%</b> 증가 하였습니다.
                </div>
                <div style="color: #1951dc;">
                  👉 다른 분석 메뉴를 이용하여, 더욱 풍부한 인사이트를 발견하세요.
                </div>
              </div>
              <div v-if="this.top_rank_brand_rate_diff < 0"> 
                <div style="margin-bottom: 4px;">
                  • <b>{{ this.top_rank_brands }}</b>는 <b>{{ this.sel_date_from }}</b> 대비 <b>{{ this.sel_date_to }}</b>에 <img src="@/assets/images/etc/negative.png" style="width: 0.7rem"/> <b>{{ Math.abs(this.top_rank_brand_rate_diff).toFixed(1) }}%</b> 감소 하였습니다.
                </div>
                <div style="color: #1951dc;">
                  👉 다른 분석 메뉴를 이용하여, 더욱 풍부한 인사이트를 발견하세요.
                </div>
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="4">
          <div v-if="!this.isBusy && this.fetchGroups != null" style="border-width: 2px; border-color: #b4bec8; border-style: solid; border-radius: 5px; background-color: aliceblue; margin-bottom: 5px;">          
            <div style="text-align: left; color: #5e5873; font-size: 13px; margin: 5px;">
              <div v-if="this.fetchGroups.length == 1">
                • 가장 많이 검색된 키워드는 🥇<b>{{ this.fetchGroups[0].keyword }}</b> 입니다.
              </div>
              <div v-else-if="this.fetchGroups.length == 2">
                • 가장 많이 검색된 키워드는 🥇<b>{{ this.fetchGroups[0].keyword }}</b> 였으며, 그 뒤로 🥈<b>{{ this.fetchGroups[1].keyword }}</b> 가 있습니다.
              </div>
              <div v-if="this.fetchGroups.length > 2">
                • 가장 많이 검색된 키워드는 🥇<b>{{ this.fetchGroups[0].keyword }}</b> 였으며, 그 뒤로 🥈<b>{{ this.fetchGroups[1].keyword }}</b>, 🥉<b>{{ this.fetchGroups[2].keyword }}</b> 가 있습니다.
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-card>

    </section>
</template>



<script>
import { 
    BCard, 
    BCol, 
    BRow, 
    BCardBody, 
    BButton,
    BCardText,
    BFormRadio, 
    BTable, 
    BPagination,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BTooltip,
    BImg,
} from "bootstrap-vue";

import FlatPickr from "vue-flatpickr-component";
import vSelect from "vue-select";
import moment from "moment";
import ToastificationContent from "@core/components/toastification/ToastificationContent";

import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index.js'
import 'flatpickr/dist/plugins/monthSelect/style.css'

import CompetitionChartDonut from "@/views/cis-competition/components/CompetitionChartDonut.vue";
import CompetitionChartBar from "@/views/cis-competition/components/CompetitionChartBar.vue";

import CompetitionChartLine from "@/views/cis-competition/components/CompetitionChartLine.vue";

import CisCompetitionService from "@/services/cis-competition.service";
import CategoryService from "@/services/category.service";

import useAppConfig from "@core/app-config/useAppConfig";

import ExportPDF from "@/components/pdfExport";
import debounce from "lodash";

import * as XLSX from 'xlsx';

import axios from "axios"

const stringStyle = { font: { name: 'Consolas' } };
const indexNumStyle = { font: { name: 'Consolas' }, numFmt: "0" };
const intNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0" };
const intNumColorStyle = { font: { name: 'Consolas' }, numFmt: "[Blue]\\ \\▲#,##0;[Red]\\ \\▼#,##0;[Black]\\ \"-\"" };
const floatNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0.0" };
const rateNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0.0%" };
const rateNumColorStyle = { font: { name: 'Consolas' }, numFmt: "[Blue]\\ \\▲#,##0%;[Red]\\ \\▼#,##0%;[Black]\\ \"-\"" };

const boldStyle = { font: { name: 'Consolas', bold: true } };
const underlineStyle = { font: { name: 'Consolas', underline: true} };

const sleep = delay => new Promise(resolve => setTimeout(resolve, delay));

const colNameDict = {
  '추천/순위/종류': 'reco_rank_type',
  '비교/후기': 'comp_review',
  '등급': 'grade',
  '신체부위/증상': 'body_parts',
  '단점/부작용': 'side_effect',
  '인물/광고': 'person_ad',
  '기간': 'season_period', 
  '국가': 'country', 
  '지역': 'region', 
  '성별': 'gender', 
  '연령대': 'age_range', 
  '대상': 'target', 
  '기능': 'function',
  '색상': 'color',
  '디자인': 'design', 
  '소재/원료': 'material', 
  '맛': 'taste', 
  '형태': 'shape', 
  '용량/크기': 'size', 
  '두께/무게': 'weight', 
  '공간/장소': 'place', 
  '용도/목적': 'purpose',
  '생산/가공': 'manufacture',
  '차량종류': 'car_type',
  '계약내용': 'contract_details',
  '금리': 'interest_rate',
  '담보': 'pawn',
  '먹거리': 'food',
  '볼거리': 'attractions',
  '놀거리': 'activities',
  '숙박': 'accommodations',
  '교통수단': 'transportation',
  '시트/크림': 'sheet_cream',
  '토핑': 'toppings',
  '생산국': 'prod_country',
  '연식': 'model_year',
  '겉감': 'outshell',
  '충전재': 'filling',
  '기장': 'length',
  '핏': 'fit',
  '패턴/프린트': 'pattern',
  '넥라인': 'neckline',
  '디테일/부자재': 'trimmings',
  '렌탈': 'rental',
  '사용료': 'fee',
  '가격/프로모션': 'price_promotion',
  '가입/구매': 'join_purchase',
  '구매처': 'place_purchase',
  '설치/시공': 'installation',
  '사용': 'usage',
  '고장/에러코드': 'failure_errcd',
  '부품/소모품': 'parts',
  '케어서비스': 'care_service',
  '멤버십/회원': 'membership',
  'AS/고객센터': 'as_center',
  '청소': 'cleaning',
  '불만사항': 'complaint',
  '폐기/해지': 'discard_cancel',
  '긍정/부정': 'pos_neg'
};

const cancelToken = axios.CancelToken;
var source = cancelToken.source();

var sel_category = 9999;

export default {
  name: "Competition",
  components: {
    FlatPickr,
    BCard,
    BCol,
    BRow,
    BCardBody,
    vSelect,
    BButton,
    BTable,
    BPagination,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BTooltip,
    BImg,

    CompetitionChartDonut,
    CompetitionChartBar,

    CompetitionChartLine,
  },
  data() {
    return {
      isPdfExporting: false,
      isXlsExporting: false,

      isBusy: false,
      lnChartInit: false,

      selectedDates: [],

      totalFreq: 0,
      donutChartData: [],
      barChartData: [],
      barChartCategory: [],
      height: 0,
      barChartFreq: [],

      majorClassList: [],      
      middleClassList: [],
      firstAttributeList: [],
      secondAttributeList: [],
      brandList: [],

      selectedMajorClass: "",
      selectedMiddleClass: "",
      selectedFirstAttribute: "",
      selectedSecondAttribute: "",
      selectedBrandList: [],

      selectedOptions: [],

      lineChartCategories: [],
      lineChartData: [],
      lineChartDesc: [],

      tableColumns: [
        { key: 'rank', label: '순위',  sortable: true, thClass: 'text-center', tdClass: 'text-center'},
        { key: 'keyword', label: '키워드', sortable: true , thClass: 'text-center' },
        { key: 'frequency', label: '검색량', sortable: true , thClass: 'text-center', tdClass: 'text-right'},
      ],

      fetchGroups: null,

      sel_category_title: "",
      sel_date_from: "",
      sel_date_to: "",
      brand_share_rate: "",
      nonbrand_share_rate: "",
      top_rank_brands: "",
      top_rank_brand_rate_diff: 0,

      form: {
        monthSelect: []
      },
      configs: {
          monthSelect: {
              mode: "range",
              altFormat: 'Y-m',
              plugins: [
                  new monthSelectPlugin({
                      shorthand: true,
                      dateFormat: "Y-m",
                  })
              ],
              locale: {
                  rangeSeparator: ' ~ '
              },
              minDate:"2018-01-01",
              maxDate: moment().endOf('month').format('YYYY-MM-DD') // 이번 달 말일로 지정
          }
      },

      sortBy: null,
      sortDesc: false,
      sortDirection: 'desc',
    };
  },
  computed: {
    check_selectedCategory(){
      console.log('---------- computed // check_selectedCategory ----------')
      console.log(' sel category : ' + this.$store.getters.getSelectedCategory)

      return this.$store.getters.getSelectedCategory
    },

    isSelectAll_cond: {
      get() {
        return this.brandList.length == this.selectedBrandList.length 
      },
      set() {
      }
    },

    isSelectSome_cond: {
      get() {
        return this.selectedBrandList.length > 0
      },
      set() {
      }
    },
  },
  watch: {
    sortDesc(val) {
      if(val)
        this.sortBy = null
    },

    check_selectedCategory(val){
      console.log('---------- watch // check_selectedCategory ----------')
      console.log(' sel category : ' + val)
      console.log(' cur category : ' + sel_category)

      if (sel_category != val) {
        this.abort(true, 'change category')

        sel_category = val;
      }

      this.selectedMajorClass = null;
      this.selectedFirstAttribute = null;
      this.selectedSecondAttribute = null;

      this.setMajorClasses();
      this.runAnalysis();
    },

    selectedMajorClass(){
      this.selectedMiddleClass = null;
      this.selectedFirstAttribute = null;
      this.selectedSecondAttribute = null;

      this.setMiddleClasses();
      this.setFirstAttributes();
    },

    selectedMiddleClass(){
      this.selectedFirstAttribute = null;
      this.selectedSecondAttribute = null;

      this.setFirstAttributes()
    },

    selectedFirstAttribute(){
      this.selectedSecondAttribute = null;

      this.setSecondAttributes()
    },

    selectedBrandList(){
      this.loadDataLine();
      this.loadDataTable();
    }
  },
  methods: {
    changeFilter() {
      if(this.selectedBrandList.length == 0 || this.selectedBrandList.length == this.brandList.length)
        document.getElementById('sel-brands').parentNode.parentNode.querySelector("label[for='sel-brands']").innerHTML = '브랜드(전체)'
      else
        document.getElementById('sel-brands').parentNode.parentNode.querySelector("label[for='sel-brands']").innerHTML = '브랜드 선택(다중)'
    },

    datePickerOnOpen(selectedDates, dateStr, instance) {
      if (document.querySelector(".fp-max-duration-info") == null) {
        var divEl = document.createElement("div"); 
        divEl.setAttribute('class', 'fp-max-duration-info');   
        divEl.setAttribute('align', 'left');   
        divEl.setAttribute('style', 'margin: 2px 10px; font-family: NanumBarunGothic; font-size: 12px; font-weight: 600; color: #17a2b8;');   
        divEl.innerHTML = "&#9888; 분석기간은 최대 3년 입니다.";
        document.querySelector(".flatpickr-calendar").appendChild(divEl);
      }
    },

    datePickerOnChange(selectedDates, dateStr, instance) {
      instance.element.value = dateStr.replace('to', '~')

      var [st_dt, en_dt] = selectedDates;
      
      if (en_dt == null) {
        var newMindate = moment(st_dt).add(-35, 'month')
        var newMaxdate = moment(st_dt).add( 35, 'month')

        if (newMindate.isBefore(this.configs.monthSelect.minDate)) 
          newMindate = moment(this.configs.monthSelect.minDate);

        if (newMaxdate.isAfter(this.configs.monthSelect.maxDate)) 
          newMaxdate = moment(this.configs.monthSelect.maxDate);

        instance.config.minDate = newMindate.toDate()
        instance.config.maxDate = newMaxdate.toDate()
      }
    },

    datepickerCloseHandler(selectedDates, dateStr, instance) {
      var [st_dt, en_dt] = selectedDates;

      if (en_dt) {
        var diff_month = (en_dt.getYear() - st_dt.getYear()) * 12 + (en_dt.getMonth() - st_dt.getMonth() + 1);

        if (diff_month > 36) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "설정 가능한 최대 분석 기간은 3년(36개월)입니다." || "Unknown error",
              icon: "AlertCircleIcon",
              variant: "warning",
            },
          });

          var curr_dt = new Date()
          var avail_diff_month = (curr_dt.getYear() - st_dt.getYear()) * 12 + (curr_dt.getMonth() - st_dt.getMonth());

          if (avail_diff_month > 35)
            avail_diff_month = 35

          en_dt = moment(st_dt).add(avail_diff_month, 'month').toDate()

          this.form.monthSelect = [st_dt, en_dt]
        }
        else
          this.form.monthSelect = selectedDates;

        var st_dt_str = moment(st_dt).format("YYYY-MM")
        var en_dt_str = moment(en_dt).format("YYYY-MM")

        if(this.selectedDates[0] != st_dt_str || this.selectedDates[1] != en_dt_str){
          this.selectedDates = []
          this.selectedDates.push(st_dt_str)
          this.selectedDates.push(en_dt_str)
          this.$store.dispatch('callPeriodSt', { st_dt: st_dt })
          this.$store.dispatch('callPeriodEn', { en_dt: en_dt })
        }        
      }
      else
        instance.setDate([this.form.monthSelect[0], this.form.monthSelect[1]], true)
    },

    async setMajorClasses() {
      console.log('---------- setMajorClasses ----------')

      // 카테고리 정보가 설정되지 않은 경우 리턴
      if (sel_category == '9999' && this.$store.getters.getSelectedCategory == '9999') 
        return;

      sel_category = this.$store.getters.getSelectedCategory;

      const firstClasses = await CisCompetitionService.listFirstClass({ctgSq: this.$store.getters.getSelectedCategory}, source);

      if (firstClasses.data.success) {
        console.log('---------- Major Classes list ----------')
        console.log(firstClasses.data.data)

        this.majorClassList = firstClasses.data.data;        
      }
    },

    async setMiddleClasses() {
      console.log('---------- setMiddleClasses ----------')

      this.middleClassList = [];
      this.selectedMiddleClass = null;

      // 카테고리 정보가 설정되지 않은 경우 리턴
      if (sel_category == '9999' && this.$store.getters.getSelectedCategory == '9999') 
        return;

      sel_category = this.$store.getters.getSelectedCategory;

      var st_dt_str = moment(this.form.monthSelect[0]).format("YYYY-MM")
      var en_dt_str = moment(this.form.monthSelect[1]).format("YYYY-MM")

      var sel_Major = this.selectedMajorClass != null ? this.selectedMajorClass.title : null; 

      const middleClasses = await CisCompetitionService.getmiddleclasslist({
        st_dt: st_dt_str,
        en_dt: en_dt_str,
        ctgSq: this.$store.getters.getSelectedCategory, 
        selMajor: sel_Major
      }, source);

      if (middleClasses.data.success) {
        console.log('---------- Middle Classes list ----------')
        console.log(middleClasses.data.data)

        this.middleClassList = middleClasses.data.data; 

        var _idx = this.middleClassList.findIndex((element) => element == "기타");

        if (_idx >= 0) {
          this.middleClassList = this.middleClassList.with(_idx, "중분류 없음")
          this.middleClassList.sort()
        }
      }
    },

    async setFirstAttributes() {
      var ctgSq = this.$store.getters.getSelectedCategory

      if(ctgSq == '9999')
        ctgSq = 1

      console.log('---------- setFirstAttributes ----------')

      // 카테고리 정보가 설정되지 않은 경우 리턴
      if (sel_category == '9999' && this.$store.getters.getSelectedCategory == '9999') 
        return;

      sel_category = this.$store.getters.getSelectedCategory;

      var sel_Major = this.selectedMajorClass != null ? this.selectedMajorClass.title : null; 
      var sel_Middle = this.selectedMiddleClass != null ? this.selectedMiddleClass : null; 

      if (sel_Middle == '중분류 없음')
        sel_Middle = '기타'

      const firstAttributes = await CisCompetitionService.listFirstAttribute({
        ctgSq: ctgSq, 
        selMajor: sel_Major,
        selMiddle: sel_Middle
      }, source);

      if (firstAttributes.data.success)
        this.firstAttributeList = firstAttributes.data.data;   
    },

    matchColName(propNm) {
      return colNameDict[propNm]
    },

    removeNullString(arrString) {
      var ret = [];

      for (const str of arrString) {
        if(str.length > 0) {
            ret.push(str);
        }
      }

      return ret;
    },

    async setSecondAttributes() {
      console.log('---------- setSecondAttributes ----------')

      // 카테고리 정보가 설정되지 않은 경우 리턴
      if (sel_category == '9999' && this.$store.getters.getSelectedCategory == '9999') 
        return;

      sel_category = this.$store.getters.getSelectedCategory;

      if (this.selectedFirstAttribute != null) {
        var ctgSq = this.$store.getters.getSelectedCategory

        if(ctgSq == '9999')
          ctgSq = 1

        var sel_Major = this.selectedMajorClass != null ? this.selectedMajorClass.title : null; 
        var sel_Middle = this.selectedMiddleClass != null ? this.selectedMiddleClass : null; 

        if (sel_Middle == '중분류 없음')
          sel_Middle = '기타'

        const secondAttributes = await CisCompetitionService.listSecondAttribute({
          prop: this.selectedFirstAttribute.title,
          propColNm: this.matchColName(this.selectedFirstAttribute.title),
          st_dt : this.selectedDates[0],
          en_dt : this.selectedDates[1],
          ctgSq: ctgSq,
          selMajor: sel_Major,
          selMiddle: sel_Middle
        }, source);

        if (secondAttributes && secondAttributes.status === 200) {
          console.log(secondAttributes.data)

          this.secondAttributeList = []
          this.secondAttributeList = this.removeNullString(secondAttributes.data.split(','));
        }
      }
      else {
        this.secondAttributeList = []
      }
    },

    async loadDataDonutBar(){
      console.log("---------- loadDataDonutBar ----------");

      if(document.getElementById('loadingDonut')){
        document.getElementById('loadingDonut').style.visibility = "visible";
      }
      if(document.getElementById('donutChart')){
        document.getElementById('donutChart').style.visibility = "hidden";
      }
      if(document.getElementById('loadingBar')){
        document.getElementById('loadingBar').style.visibility = "visible";
      }
      if(document.getElementById('barChart')){
        document.getElementById('barChart').style.visibility = "hidden";
      }
      if(document.getElementById('loadingLine')){
        document.getElementById('loadingLine').style.visibility = "visible";
      }
      if(document.getElementById('lineChart')){
        document.getElementById('lineChart').style.visibility = "hidden";
      }
      
      this.donutChartData = []
      this.barChartData = []
      this.barChartFreq = []
      this.barChartCategory = []
      this.selectedBrandList = []
      this.sel_category_title = ""
      this.sel_date_from = ""
      this.sel_date_to = ""
      this.brand_share_rate = 0.0
      this.nonbrand_share_rate = 0.0

      var fcls_sq = null
      var fattr_sq = null
      var sattr_nm = null
      var col_nm = null

      if(this.selectedMajorClass != null)
        fcls_sq = this.selectedMajorClass.id
      
      if(this.selectedFirstAttribute != null){
        fattr_sq = this.selectedFirstAttribute.id
        col_nm = this.matchColName(this.selectedFirstAttribute.title)
      }

      if(this.selectedSecondAttribute != null)
        sattr_nm = this.selectedSecondAttribute

      const response = await CisCompetitionService.getCompetitionDataDonutBar({
        startDate : this.selectedDates[0],
        endDate : this.selectedDates[1],
        ctgSq : this.$store.getters.getSelectedCategory,
        fclsSq : fcls_sq,
        fattrSq : fattr_sq,
        colNm: col_nm,
        sattrNm : sattr_nm
      }, source);

      if (response && response.status === 200) {
        console.log(response)

        // total freq update
        this.totalFreq = response.data.data.donutData[0].totalFreq
        
        // donut chart update
        this.donutChartData = [response.data.data.donutData[0].brandedFreq, response.data.data.donutData[0].nonbrandedFreq]
        // bar chart update
        this.barChartData = []
        this.barChartCategory = []
        this.brandList = []
        this.selectedBrandList = []
        
        var idx_barData = 0

        for(const item of response.data.data.barData) {
          idx_barData+=1
          this.barChartData.push(item.rate)
          this.barChartCategory.push(item.brand)
          this.brandList.push(item.brand)
          this.barChartFreq.push(item.freq)

          if(idx_barData < 5){
            this.selectedBrandList.push(item.brand)
          }
        }

        const catServResp = await CategoryService.getOneCategory(this.$store.getters.getSelectedCategory, source);
        
        if (catServResp.data.success)
          this.sel_category_title = catServResp.data.data.title;

        this.sel_date_from = moment(this.selectedDates[0]).format('YYYY-MM');
        this.sel_date_to = moment(this.selectedDates[1]).format('YYYY-MM');

        this.brand_share_rate = response.data.data.donutData[0].brandedRate
        this.nonbrand_share_rate = response.data.data.donutData[0].nonbrandedRate

        document.getElementById('loadingDonut').style.visibility = "hidden";
        document.getElementById('donutChart').style.visibility = "visible";
        document.getElementById('loadingBar').style.visibility = "hidden";
        document.getElementById('barChart').style.visibility = "visible";

      }
    },

    async loadDataLine(){
      console.log('---------- loadDataLine ----------')

      document.getElementById('loadingLine').style.visibility = "visible";
      document.getElementById('lineChart').style.visibility = "hidden";

      this.lnChartInit = false;

      this.lineChartData = []
      this.lineChartCategories = []
      this.lineChartDesc = []

      this.top_rank_brands = ""
      this.top_rank_brand_rate_diff = 0;

      var fcls_sq = null
      var fattr_sq = null
      var sattr_nm = null
      var col_nm = null

      if(this.selectedMajorClass != null)
        fcls_sq = this.selectedMajorClass.id
      
      if(this.selectedFirstAttribute != null){
        fattr_sq = this.selectedFirstAttribute.id
        col_nm = this.matchColName(this.selectedFirstAttribute.title)
      }

      if(this.selectedSecondAttribute != null)
        sattr_nm = this.selectedSecondAttribute

      var temp_brand_list = [];

      if(this.selectedBrandList.length > 0)
        temp_brand_list = this.selectedBrandList;
      else
        temp_brand_list = this.brandList;  
      
      if(temp_brand_list.length > 0)
      {
        const response = await CisCompetitionService.getCompetitionDataLine({
          startDate : this.selectedDates[0],
          endDate : this.selectedDates[1],
          ctgSq : this.$store.getters.getSelectedCategory,
          fclsSq : fcls_sq,
          fattrSq : fattr_sq,
          colNm: col_nm,
          sattrNm : sattr_nm,
          brandList : temp_brand_list
        }, source);

        if (response && response.status === 200) {
          console.log(response)

          this.lnChartInit = true;
          this.lineChartData = []
          this.lineChartCategories = []
          this.lineChartDesc = []

          for(const item of response.data.data) {
              this.lineChartData.push({
                brand: item.brand,
                type: 'line',
                data: item.rate.split(','),
                description: item.freq.split(','),
                hidden: true
              })

              if (this.lineChartCategories.length == 0) 
                this.lineChartCategories = item.date.split(',')
              
              this.lineChartDesc.push(item.freq.split(','))
          }
          
          if (this.lineChartData.length > 0) {
            this.top_rank_brands = this.lineChartData[0].brand;
            this.top_rank_brand_rate_diff = this.lineChartData[0].data[this.lineChartCategories.length - 1] - this.lineChartData[0].data[0];
          }
          
          document.getElementById('loadingLine').style.visibility = "hidden";
          document.getElementById('lineChart').style.visibility = "visible";
        }
      }
      else {
        console.log('no-brandList!!')
        this.lnChartInit = true;
      }
    },

    async loadDataTable(){
      console.log('---------- loadDataTable ----------')

      this.isBusy = true

      var fcls_sq = null
      var fattr_sq = null
      var sattr_nm = null
      var col_nm = null

      var temp_brand_list = [];

      if(this.selectedBrandList.length > 0)
        temp_brand_list = this.selectedBrandList;
      else
        temp_brand_list = this.brandList;

      if(temp_brand_list.length > 0)
      {
        if(this.selectedMajorClass != null)
          fcls_sq = this.selectedMajorClass.id
        
        if(this.selectedFirstAttribute != null) {
          fattr_sq = this.selectedFirstAttribute.id
          col_nm = this.matchColName(this.selectedFirstAttribute.title)
        }

        if(this.selectedSecondAttribute != null)
          sattr_nm = this.selectedSecondAttribute       

        const response = await CisCompetitionService.getCompetitionDataTable({
          startDate : this.selectedDates[0],
          endDate : this.selectedDates[1],
          ctgSq : this.$store.getters.getSelectedCategory,
          fclsSq : fcls_sq,
          fattrSq : fattr_sq,
          colNm: col_nm,
          sattrNm : sattr_nm,
          brandList : temp_brand_list
        }, source);

        if (response && response.status === 200) {
          console.log(response)

          this.isBusy = false
          this.fetchGroups = null
          this.fetchGroups = response.data.data
        }
      }
      else
        console.log('no-brandList!!')
    },

    competitionChartLineSeries(cd) {
      const chartSeries = [];

      for (const item of cd)
        chartSeries.push({ name: item.brand, type: item.type, data: item.data, hidden: false })

      return chartSeries;
    },

    getToday() {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
      let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()

      return year + month + day
    },

    exportToPDF: _.debounce(async function() {
      this.isPdfExporting = true;

      await sleep(1);

      var ret = await ExportPDF.exportToPDF([this.$refs.comPrintArea1, this.$refs.comPrintArea2], 'a4', 'l', 'share_of_search_' + this.getToday() + '.pdf');

      if (ret) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "PDF export complete!!",
            icon: "EditIcon",
            variant: "success",
          },
        });
      }
      else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "PDF export fail!!",
            icon: "AlertCircleIcon",
            variant: "warning",
          },
        });
      }

      this.isPdfExporting = false;
    }, 100),

    newSheet4Intro(dataOrigin, category, major, prop, prop_details, period, serviceName) {
      var tmp_sheet = []

      tmp_sheet.push([]);
      tmp_sheet.push(['', { v: 'CONSUMER in SEARCH Ai', t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { t: "s", v: "consumerinsearch.com", l: {Target: "https://consumerinsearch.com"}, s: underlineStyle}]);
      tmp_sheet.push([]);
      tmp_sheet.push(['', { v: '데이터 개요', t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '데이터 출처: ', t: "s", s: boldStyle }, { v: dataOrigin, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '카테고리: ', t: "s", s: boldStyle }, { v: category, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '대분류: ', t: "s", s: boldStyle }, { v: major, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '속성: ', t: "s", s: boldStyle }, { v: prop, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '세부 속성: ', t: "s", s: boldStyle }, { v: prop_details, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '분석 기간: ', t: "s", s: boldStyle }, { v: period, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '서비스명: ', t: "s", s: boldStyle }, { v: serviceName, t: "s", s: boldStyle }]);

      var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
      ws['!cols'] = this.autoFit(tmp_sheet)

      return ws;
    },

    newSheet4Data(dataOrigin, category, major, prop, prop_details, period, columns, data) {
      var tmp_sheet = [];

      // Information
      tmp_sheet.push([{ v: '데이터 출처: ', t: "s", s: boldStyle }, { v: dataOrigin, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '카테고리: ', t: "s", s: boldStyle }, { v: category, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '대분류: ', t: "s", s: boldStyle }, { v: major, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '속성: ', t: "s", s: boldStyle }, { v: prop, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '세부 속성: ', t: "s", s: boldStyle }, { v: prop_details, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '분석 기간: ', t: "s", s: boldStyle }, { v: period, t: "s", s: boldStyle }]);
      tmp_sheet.push([]);

      // Header
      var header_list = ['No.', '키워드'].concat(columns)
      var tmp_header = [];

      for (const col_nm of header_list) {
        tmp_header.push({ v: col_nm, t: "s", s: boldStyle });
      };

      tmp_sheet.push(tmp_header);

      // Data
      var totalFreq = 0;
      var totalRate = 0;

      // Frequence summation
      for (const idx in data)
        totalFreq += Number(data[idx].freq);

      for (const idx in data) {
        var tmp_row = [];
        var rate = Number(data[idx].freq) / totalFreq

        tmp_row.push({t: "n", v: Number(idx) + 1, s: indexNumStyle});       // No.
        tmp_row.push({t: "s", v: data[idx].keyword, s: stringStyle});       // 키워드
        tmp_row.push({t: "n", v: Number(data[idx].freq), s: intNumStyle});  // 검색량        
        tmp_row.push({t: "n", v: rate, s: rateNumStyle});                   // 비율        

        totalRate += rate;

        tmp_sheet.push(tmp_row)
      }

      // Total Row
      tmp_sheet.push([]);
      tmp_sheet.push(['', {t: "s", v: 'Total', s: stringStyle}, {t: "n", v: totalFreq, s: intNumStyle}, {t: "n", v: totalRate, s: rateNumStyle}
                     ]);
      
      var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
      ws['!cols'] = this.autoFit(tmp_sheet)

      return ws;
    },

    newSheet4TrackingData(dataOrigin, category, major, prop, prop_details, period, brands, columns, data) {
      var tmp_sheet = [];
      var brandStr = brands.join(', ');
      var freqTotal = [];
      var rateTotal = [];

      // Information
      tmp_sheet.push([{ v: '데이터 출처: ', t: "s", s: boldStyle }, { v: dataOrigin, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '카테고리: ', t: "s", s: boldStyle }, { v: category, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '대분류: ', t: "s", s: boldStyle }, { v: major, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '속성: ', t: "s", s: boldStyle }, { v: prop, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '세부 속성: ', t: "s", s: boldStyle }, { v: prop_details, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '분석 기간: ', t: "s", s: boldStyle }, { v: period, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '브랜드: ', t: "s", s: boldStyle }, { v: brandStr, t: "s", s: boldStyle }]);
      tmp_sheet.push([]);

      // Header
      var header_list = ['No.', '키워드'].concat(columns)
      var tmp_header = [];

      for (const col_nm of header_list) {
        tmp_header.push({ v: col_nm, t: "s", s: boldStyle });
        freqTotal.push(0);
        rateTotal.push(0);
      };

      tmp_sheet.push([{ v: '검색량', t: "s", s: boldStyle }]);
      tmp_sheet.push(tmp_header);

      // 검색량 Data
      for (const idx in data) {
        var tmp_row = [];
        tmp_row.push({t: "n", v: Number(idx) + 1, s: indexNumStyle}); // No.
        tmp_row.push({t: "s", v: data[idx].keyword, s: stringStyle}); // 키워드

        var sub_idx = 0;
        for (const sub_item of data[idx].freq) {  // 검색량
            tmp_row.push({t: "n", v: Number(sub_item), s: intNumStyle});
            freqTotal[sub_idx] += Number(sub_item);
            sub_idx++;
        };

        tmp_sheet.push(tmp_row)
      }

      var freqTotalRow = ['', 'Total'];

      for (const idx in columns)
        freqTotalRow.push({t: "n", v: Number(freqTotal[idx]), s: intNumStyle});

      tmp_sheet.push([]);
      tmp_sheet.push(freqTotalRow);
      tmp_sheet.push([]);
      tmp_sheet.push([]);
      tmp_sheet.push([{ v: '비율', t: "s", s: boldStyle }]);
      tmp_sheet.push(tmp_header);

      // 비율 Data
      for (const idx in data) {
        var tmp_row = [];
        tmp_row.push({t: "n", v: Number(idx) + 1, s: indexNumStyle}); // No.
        tmp_row.push({t: "s", v: data[idx].keyword, s: stringStyle}); // 키워드

        var sub_idx = 0;
        for (const sub_item of data[idx].rate) {  // 비율
            tmp_row.push({t: "n", v: Number(sub_item / 100).toFixed(5), s: rateNumStyle});
            rateTotal[sub_idx] += Number(sub_item);
            sub_idx++;
        };

        tmp_sheet.push(tmp_row)
      }

      var rateTotalRow = ['', 'Total'];

      for (const idx in columns)
        rateTotalRow.push({t: "n", v: Number(rateTotal[idx] / 100).toFixed(5), s: rateNumStyle});

      tmp_sheet.push([]);
      tmp_sheet.push(rateTotalRow);
     
      var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
      ws['!cols'] = this.autoFit(tmp_sheet)

      return ws;
    },

    newSheet4TopRankKeyword(dataOrigin, category, major, prop, prop_details, period, brands, columns, data) {
      var tmp_sheet = [];
      var brandStr = brands.join(', ');

      // Information
      tmp_sheet.push([{ v: '데이터 출처: ', t: "s", s: boldStyle }, { v: dataOrigin, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '카테고리: ', t: "s", s: boldStyle }, { v: category, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '대분류: ', t: "s", s: boldStyle }, { v: major, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '속성: ', t: "s", s: boldStyle }, { v: prop, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '세부 속성: ', t: "s", s: boldStyle }, { v: prop_details, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '분석 기간: ', t: "s", s: boldStyle }, { v: period, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '브랜드: ', t: "s", s: boldStyle }, { v: brandStr, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '*검색량 상위 키워드는 최대 500개까지 제공됩니다.', t: "s", s: boldStyle }]);
      tmp_sheet.push([]);

      // Header
      var header_list = ['No.', '키워드'].concat(columns)
      var tmp_header = [];

      for (const col_nm of header_list) {
        tmp_header.push({ v: col_nm, t: "s", s: boldStyle });
      };

      tmp_sheet.push(tmp_header);

      // Data
      for (const item of data) {
        var tmp_row = [];
        tmp_row.push({t: "n", v: Number(item.rank), s: indexNumStyle});                               // No.
        tmp_row.push({t: "s", v: item.keyword, s: stringStyle});                                      // 키워드
        tmp_row.push({t: "n", v: Number(item.frequency.trim().replaceAll(',', '')), s: intNumStyle}); // 검색량
        tmp_row.push({t: "s", v: item.brand, s: stringStyle});                                        // 브랜드  

        tmp_sheet.push(tmp_row)
      }
      
      var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
      ws['!cols'] = this.autoFit(tmp_sheet)

      return ws;
    },

    autoFit(data) {
      const wsCols = [];

      data.map((item) => {
        Object.keys(item).map((key, index) => {
          let text = item[key];
          let maxWidth;

          switch(typeof text) {
            case 'number':
              if (wsCols[index]) {
                if (text)
                  maxWidth = wsCols[index].width > 10 ? wsCols[index].width : 10;
                else
                  maxWidth = 10;
              }
              else
                maxWidth = text !== null ? 10 : 0;
                         
              break;
            case 'object':
              if (wsCols[index]) {
                if (text && text['v']) {
                  if (typeof text['v'] === 'number')
                    maxWidth = wsCols[index].width > 10 ? wsCols[index].width : 10;
                  else
                    maxWidth = wsCols[index].width < text['v'].length * 1.5 ? text['v'].length * 1.5 : wsCols[index].width;
                }
                else
                  maxWidth = wsCols[index].width;
              }
              else {
                if (text && text['v']) {
                  if (typeof text['v'] === 'number')
                    maxWidth = text['v'] !== null ? 10 : 0;
                  else
                    maxWidth = text['v'] !== null ? text['v'].length * 1.5 : 0;
                }
                else
                    maxWidth = 0;
              }

              break;
            case 'string':
              if (wsCols[index]) {
                if (text)
                  maxWidth = wsCols[index].width < text.length * 1.5 ? text.length * 1.5 : wsCols[index].width;
                else 
                  maxWidth = wsCols[index].width;
              }
              else 
                maxWidth = text !== null ? text.length * 1.5 : 0;
               
              break;
          }

          wsCols[index] = {width : maxWidth}
        })
      })

      for (var index in wsCols)
        wsCols[index].width = wsCols[index].width === 0 ? 10 : wsCols[index].width * 1.5;

      return wsCols
    },

    exportToExcel: _.debounce(async function() {
      const XLSX = require("xlsx-js-style");

      this.isXlsExporting = true;

      await sleep(1);

      try {
        var st_dt_str = moment(this.form.monthSelect[0]).format("YYYY-MM")
        var en_dt_str = moment(this.form.monthSelect[1]).format("YYYY-MM")

        const dataOrigin = 'NAVER';
        var category = 'Unknown';

        const catServResp = await CategoryService.getOneCategory(this.$store.getters.getSelectedCategory, source);

        if (catServResp.data.success)
          category = catServResp.data.data.title

        const period = st_dt_str + ' ~ ' + en_dt_str;

        var major = '전체';
        var prop = '전체';
        var prop_detail = '전체';

        if (this.selectedMajorClass != null && this.selectedMajorClass.title.length > 0)
          major = this.selectedMajorClass.title;

        if (this.selectedFirstAttribute != null && this.selectedFirstAttribute.title.length > 0)
          prop = this.selectedFirstAttribute.title;

        if (this.selectedSecondAttribute != null && this.selectedSecondAttribute.title.length > 0)
          prop_detail = this.selectedSecondAttribute.title;

        const workbook = XLSX.utils.book_new()	// 엑셀 생성

        XLSX.utils.book_append_sheet(workbook, 
                                     this.newSheet4Intro(dataOrigin, category, major, prop, prop_detail, period, 'SHARE OF SEARCH'), 
                                     '데이터 개요') 

        var brandCompData = [];

        for (const idx in this.donutChartData) {
          if (idx == 0)
            brandCompData.push({
              keyword: 'BRANDED',
              freq: this.donutChartData[idx],
              rate: this.donutChartData[idx] / this.totalFreq * 100
            }); 
          else
            brandCompData.push({
              keyword: 'NONBRANDED',
              freq: this.donutChartData[idx],
              rate: this.donutChartData[idx] / this.totalFreq * 100
            }); 
        }

        XLSX.utils.book_append_sheet(workbook, 
                                     this.newSheet4Data(dataOrigin, category, major, prop, prop_detail, period, ['검색량', '비율'], brandCompData), 
                                     '브랜드 vs. 논브랜드')

        var brandShareData = [];

        for (const idx in this.barChartData) {
          brandShareData.push({
            keyword: this.barChartCategory[idx],
            // freq: Math.round((this.barChartData[idx] / 100) * this.totalFreq),
            freq: this.barChartFreq[idx],
            rate: this.barChartData[idx]
          }); 
        }

        XLSX.utils.book_append_sheet(workbook, 
                                     this.newSheet4Data(dataOrigin, category, major, prop, prop_detail, period, ['검색량', '비율'], brandShareData), 
                                     '브랜드 점유율')

        var brandShareTrackingData = [];

        for (const idx in this.lineChartData) {
          brandShareTrackingData.push({
            keyword: this.lineChartData[idx].brand,
            freq: this.lineChartData[idx].description,
            rate: this.lineChartData[idx].data
          }); 
        }

        XLSX.utils.book_append_sheet(workbook, 
                                     this.newSheet4TrackingData(dataOrigin, category, major, prop, prop_detail, period, this.selectedBrandList, this.lineChartCategories, brandShareTrackingData), 
                                     '브랜드 점유율 트래킹')

        var fcls_sq = null
        var fattr_sq = null
        var sattr_sq = null

        if(this.selectedBrandList.length > 0)
        {
          if(this.selectedMajorClass != null)
            fcls_sq = this.selectedMajorClass.id
          
          if(this.selectedFirstAttribute != null)
            fattr_sq = this.selectedFirstAttribute.id
          
          if(this.selectedSecondAttribute != null)
            sattr_sq = this.selectedSecondAttribute.id        

          const cisCompResp = await CisCompetitionService.getCompetitionDataTableExp({
            startDate : this.selectedDates[0],
            endDate : this.selectedDates[1],
            ctgSq : this.$store.getters.getSelectedCategory,
            fclsSq : fcls_sq,
            fattrSq : fattr_sq,
            sattrSq : sattr_sq,
            brandList : this.selectedBrandList
          }, source);

          if (cisCompResp && cisCompResp.status === 200)
            XLSX.utils.book_append_sheet(workbook, 
                                         this.newSheet4TopRankKeyword(dataOrigin, category, major, prop, prop_detail, period, this.selectedBrandList, ['검색량', '브랜드'], cisCompResp.data.data), 
                                         '검색량 상위 키워드')    
        }    

        XLSX.writeFile(workbook, 'share_of_search_' + this.getToday() + '.xlsx')	// 엑셀 다운로드

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Excel export complete!!",
            icon: "EditIcon",
            variant: "success",
          },
        });
      }
      catch (err) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Excel export fail!!",
            icon: "AlertCircleIcon",
            variant: "warning",
          },
        });
      }

      this.isXlsExporting = false;
    }, 100),

    removeSelItem(target, sel_idx) {
      target.splice(sel_idx, 1)
      target = [...target]

      this.changeFilter()
    },

    abort(isReset, message) {
      console.log('---------- abort ---------- // ' + message)

      // cancel the request
      source.cancel(message);

      if (isReset)
        source = cancelToken.source();
    },

    selectAllCond() {
      if (this.isSelectAll_cond)
        this.selectedBrandList = []
      else
        this.selectedBrandList = this.brandList

      this.changeFilter()
    },

    runAnalysis() {
      if(this.$store.getters.getSelectedCategory != '9999'){
        this.loadDataDonutBar();
      }
    }
  },

  mounted(){
    console.log('---------- mounted ----------')

    setTimeout(() => {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }, 200);
  },

  destroyed() {
    console.log('---------- destroyed ----------')
    
    this.abort(false, 'destoryed')
  },

  async created() {
    console.log('---------- create ----------')
    console.log(' sel category : ' + this.$store.getters.getSelectedCategory)
    console.log(' cur category : ' + sel_category)

    this.abort(true, 'created')

    this.$store.dispatch('callCISMenu', { cisMenu: 'competition' })

    this.selectedMajorClass = null;
    this.selectedFirstAttribute = null;
    this.selectedSecondAttribute = null;
    this.selectedOptions.push(this.$store.getters.getSelectedCategory)
    this.selectedOptions.push(this.selectedMajorClass)
    this.selectedOptions.push(this.selectedFirstAttribute)
    this.selectedOptions.push(this.selectedSecondAttribute)
    this.selectedOptions.push(this.selectedDates)
    this.setMajorClasses();

    var st_dt = this.$store.getters.getSelectedPeriodSt
    var en_dt = this.$store.getters.getSelectedPeriodEn

    if (st_dt.length == 0 || en_dt.length == 0) {
      en_dt = moment().add(-2, 'days').toDate() // 데이터 업데이트 시점을 고려
      st_dt = new Date(en_dt)

      st_dt.setMonth(en_dt.getMonth() - 11)
    }

    this.form.monthSelect = [st_dt, en_dt]

    var st_dt_str = moment(st_dt).format("YYYY-MM")
    var en_dt_str = moment(en_dt).format("YYYY-MM")

    this.selectedDates.push(st_dt_str)
    this.selectedDates.push(en_dt_str)

    this.lineChartData = [];
    this.lineChartCategories = [] 

    this.runAnalysis();
  },
}

</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";

#competitionDonutCol .apexcharts-canvas .apexcharts-text, 
#competitionDonutCol .apexcharts-canvas .apexcharts-tooltip-text, 
#competitionDonutCol .apexcharts-canvas .apexcharts-datalabel-label, 
#competitionDonutCol .apexcharts-canvas .apexcharts-datalabel, 
#competitionBarCol .apexcharts-canvas .apexcharts-text, 
#competitionBarCol .apexcharts-canvas .apexcharts-tooltip-text, 
#competitionBarCol .apexcharts-canvas .apexcharts-datalabel-label, 
#competitionBarCol .apexcharts-canvas .apexcharts-datalabel 
{
    font-family: "NanumBarunGothic", Arial, sans-serif !important;
    font-weight: bold;
    filter: none;
}

#competitionBarCol .apexcharts-canvas .apexcharts-datalabel-label, 
#competitionBarCol .apexcharts-canvas .apexcharts-datalabel
{
  margin-left: 5rem;
}

#competitionBarCol .graphic-container {
  min-height: 450px;
  max-height: 450px;
  overflow-y: auto;
  overflow-x: hidden;
}

.mb-1 .sticky-top{
  align-self: flex-start;
}

.tooltip-inner {
  color: #333;
  background: #fff;
  border: 1px solid #F2F2F2;
  font-family: "NanumBarunGothic", Arial, sans-serif !important;
  filter: none;
  box-shadow: 1px 1px 1px #F2F2F2;
  font-weight: bold;
}

/* Hide default icon */
.comTable .table.b-table > thead > tr > th,
.comTable .table.b-table > tfoot > tr > td {
  background-image: none !important;
  vertical-align: middle !important;
}

.comTable .table-font-size {
  font-size: 12px;
  font-weight: 600;
}

.select-brand .v-label {
  font-size: 12px;
}

.select-brand .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 6px 0;
}

.comselectitemlist .v-list-item {
  min-height: 28px;
}

.comselectitemlist .v-list-item__content {
  padding: 5px 0;
}

.comselectitemlist .v-list-item__action {
  margin: 5px 0;
}

.comselectitemlist .v-list-item__title {
  font-size: 12px !important;
  font-weight: 600 !important;
}

.sosselectallcond {
  margin: 0px !important;
  padding: 0px !important;
}

.sosselectallcond .v-input__slot {
  padding: 0 16px;
}

.sosdivider {
  margin-top: 0.1rem;
  margin-bottom: 0.1rem;
}

.major-class .vs__dropdown-menu,
.middle-class .vs__dropdown-menu,
.first-attribute .vs__dropdown-menu,
.second-attribute .vs__dropdown-menu
{
  padding: 0px 0px 0px 0px;
}

.major-class .vs__dropdown-toggle,
.middle-class .vs__dropdown-toggle,
.first-attribute .vs__dropdown-toggle,
.second-attribute .vs__dropdown-toggle 
{
  border: 2px solid #d8d6de;
}

.major-class .vs__search,
.middle-class .vs__search,
.first-attribute .vs__search,
.second-attribute .vs__search,
.major-class .vs__selected,
.middle-class .vs__selected,
.first-attribute .vs__selected,
.second-attribute .vs__selected 
{
  height: 20px;
  margin-top: 4px !important;
}

</style>
